import {Button, Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import React, {useState} from 'react';

import {Modal} from 'presentation/components/Modal';

import {UPLOAD_TERMS} from '../../constants';

type UploadTermsAcceptanceModalProps = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export function UploadTermsAcceptanceModal({
	open,
	onClose,
	onConfirm,
}: UploadTermsAcceptanceModalProps) {
	const [checked, setChecked] = useState(false);

	const handleClose = () => {
		setChecked(false);
		onClose();
	};

	const handleConfirm = () => {
		if (!checked) return;
		setChecked(false);
		onConfirm();
	};

	return (
		<Modal.Root
			open={open}
			onClose={handleClose}
			customMaxWidth={420}
			customMaxHeight="80vh"
			fullWidth>
			<Modal.Header title={UPLOAD_TERMS.headerTitle} onClose={handleClose} />

			<Modal.Content sx={{py: 3}}>
				<Typography variant="h6" sx={{mb: 2}}>
					{UPLOAD_TERMS.subtitle}
				</Typography>
				<Stack gap={2}>
					{UPLOAD_TERMS.paragraphs.map((paragraph, index) => (
						<Typography key={index} variant="body1">
							{paragraph}
						</Typography>
					))}
				</Stack>
			</Modal.Content>

			<Modal.Footer>
				<Stack spacing={1.5} flex={1} sx={{width: '100%'}}>
					<FormControlLabel
						control={
							<Checkbox
								checked={checked}
								onChange={() => setChecked(prev => !prev)}
							/>
						}
						label={UPLOAD_TERMS.checkboxLabel}
					/>
					<Button
						disabled={!checked}
						fullWidth
						size="large"
						variant="contained"
						onClick={handleConfirm}>
						{UPLOAD_TERMS.confirm}
					</Button>
				</Stack>
			</Modal.Footer>
		</Modal.Root>
	);
}
